import React, { useEffect, useMemo, useState } from "react";
import { matchPath, useHistory, useLocation } from "react-router-dom";

import { Divider, TabProps as MuiTabProps, Tab, Tabs, TabsProps } from "@mui/material";

const commonStyles: TabProps["sx"] = {
  minHeight: "20px",
  maxHeight: "25px",
  padding: "0px",
  fontSize: "15px",
  color: "#5d7782",
  minWidth: "50px"
};

const dividerStyles: TabProps["sx"] = {
  minWidth: "1px",
  minHeight: "20px",
  maxHeight: "20px"
};

interface TabProps extends MuiTabProps {
  to?: string;
  matchRouts?: string[];
}

export interface HorizontalNavBarProps extends TabsProps {
  tabs: TabProps[];
}

export const HorizontalNavBar: React.FC<HorizontalNavBarProps> = ({ tabs, ...props }: HorizontalNavBarProps) => {
  const dividerIcon = useMemo(
    () => <Divider sx={{ width: "1px", height: "16px", backgroundColor: "#DBE8F5", borderColor: "#DBE8F5" }} />,
    []
  );
  const { push } = useHistory();
  const { pathname } = useLocation();

  const currentRouterCheck = (pathname: string, routes: string[]): boolean => {
    return routes.some((route) => matchPath(pathname, route));
  };

  const enabledTab = useMemo(() => {
    const selectedTab = tabs.find((tab) => currentRouterCheck(pathname, tab.matchRouts || []));
    return selectedTab?.value;
  }, [pathname]);

  const [value, setValue] = useState(enabledTab || false);

  useEffect(() => {
    setValue(enabledTab || false);
  }, [enabledTab]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const tabsArr: React.ReactElement[] = [];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tabs.forEach(({ to, matchRouts, sx, ...tab }, index) => {
    if (!tab.hidden) {
      tabsArr.push(
        <Tab
          key={tab.value}
          sx={{ ...commonStyles, ...sx }}
          iconPosition="start"
          onClick={to ? () => push(to!) : undefined}
          {...tab}
        />
      );
    }
    const nextVisibleTabIndex = tabs.findIndex((nextTab, nextIndex) => nextIndex > index && !nextTab.hidden);

    if (nextVisibleTabIndex !== -1 && !tab.hidden) {
      tabsArr.push(<Tab key={"sep-" + index} sx={dividerStyles} label="" icon={dividerIcon} disabled />);
    }
  });

  return (
    <Tabs
      sx={{
        minHeight: "25px",
        maxHeight: "25px"
      }}
      value={value}
      onChange={handleChange}
      {...props}
    >
      {tabsArr}
    </Tabs>
  );
};
